exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-detail .loans-detail{display:block;margin-top:14px}loans-detail .loans-detail.mobile{margin-top:0;margin-bottom:75px;padding-top:0!important;padding-left:0!important;padding-right:0!important}loans-detail .loans-detail .go-back{cursor:pointer}loans-detail .loans-detail .go-back span{font-family:Stag Sans;font-size:15px;color:#0072c9;text-transform:uppercase}loans-detail .loans-detail .go-back span.icon{transform:rotate(270deg);display:inline-block;margin-right:15px;margin-bottom:28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansDetail/loansDetail.scss
// module id = 1824
// module chunks = 0